import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ModelType } from '@shared/constants/model-type.enum';
import { IPredictorData } from '@models/predictor-data.model';
import { Observable } from 'rxjs';
import { IModelPlatformProcessor } from '@models/model-platform-processor.model';
import { IModelPlatformProcessorResponse } from '@models/model-platform-processor-response.model';

@Injectable({
  providedIn: 'root'
})
export class CalculationService {
  private apiService = inject(ApiService);

  getPredictorData(projectId: number, modelType: ModelType): Observable<IPredictorData> {
    return this.apiService.get(`predictor/${projectId}`, modelType);
  }

  calculate(data: IModelPlatformProcessor, modelType: ModelType): Observable<IModelPlatformProcessorResponse> {
    return this.apiService.post('predictor/calculate', data, modelType);
  }
}